import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { MIAUser, AuthenticationService } from '@mobileia/authentication';
import { MetatagService } from 'src/app/services/metatag.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
  animations: [
    trigger(
      'cardsAnimation', [
        transition(
          ':enter',[
            style({
              opacity: 0,
              transform: 'translateY(20px)'
            }),
            animate('0.3s ease', style({
              opacity: 1,
              transform: 'translateY(0px)'
            }))
          ]
        )
      ]
    )
  ]
})
export class MyProfileComponent implements OnInit {

  sectionActive = 0;
  currentUser = new MIAUser();

  constructor(
    protected authService: AuthenticationService,
    protected metatagService: MetatagService,
    protected navigator: Router
  ) { }

  ngOnInit() {
    this.metatagService.configSlug('my-profile');
    this.loadUser();
    setTimeout(() => {
      if (this.currentUser == null || this.currentUser.id == undefined || this.currentUser.id <= 0) {
        this.navigator.navigateByUrl('/');
      }
    }, 2000);
  }

  clickSection(section) {
    this.sectionActive = section;
  }

  loadUser() {
    this.authService.currentUser.subscribe(data => {
      if (data == null) {
        return;
      }
      this.currentUser = data;
    });
  }

  onLogout() {
    this.authService.signOut();
    this.navigator.navigateByUrl('/');
    //window.location.reload();
  }
}
